export {default as PolicyViewer} from './components/PolicyViewer.vue';
export {default as Policy} from './Policy.vue';

export const PolicyViewerPage = () => import('./components/PolicyViewer.vue');
export const PolicyPage = () => import('./Policy.vue');
